import React from 'react';

import { LogoShort } from '@/resources/assets/images';

import Link from '../Link/Link';

import './Logo.scss';

const Logo = (): JSX.Element => (
	<Link className="logo" redirect to="/">
		<LogoShort width={83} height={32} />
	</Link>
);

export default Logo;
